import { Doughnut, mixins } from 'vue-chartjs';
import { Loading } from 'element-ui';
import sum from 'lodash/sum';
import api from '@/api';
import * as ChartColors from '@/util/chartColors';
import ReportData from '@/mixin/ReportData';

const { reactiveData } = mixins;

export default {
  name: 'EBDidNotQualifyChart',
  extends: Doughnut,
  mixins: [reactiveData, ReportData],
  props: {
    priorYear: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'left',
        },
        title: {
          display: true,
          text: 'Early Bird DNQ Reason',
        },
        animation: {
          animateScale: true,
          animateRotate: true,
        },
      },
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
    this.fetchData();
  },
  methods: {
    fetchData() {
      const loadingInstance = Loading.service({
        target: this.$el,
      });
      api.report.getEarlyBirdReasonsDNQ(this.dateRange, this.forOffice, this.priorYear).then((result) => {
        this.buildDataset(result.data);
      }).finally(() => {
        this.$nextTick(() => {
          loadingInstance.close();
        });
      });
    },
    buildDataset(results) {
      const values = results.values || [];
      const reasons = results.reasons || [];

      const total = sum(values);

      const availableColors = [
        ChartColors.getRGBA(ChartColors.GREEN),
        ChartColors.getRGBA(ChartColors.BLUE),
        ChartColors.getRGBA(ChartColors.RED),
        ChartColors.getRGBA(ChartColors.ORANGE),
        ChartColors.getRGBA(ChartColors.AQUA),
        ChartColors.getRGBA(ChartColors.PURPLE),
        ChartColors.getRGBA(ChartColors.YELLOW),
      ];

      const labels = [];
      const colors = [];
      for (let i = 0; i < values.length; i++) {
        labels.push(`${reasons[i]} ${this.calcPercentage(values[i], total)}`);
        colors.push(availableColors[i % availableColors.length]);
      }

      this.chartData = {
        labels,
        datasets: [
          {
            data: values,
            backgroundColor: colors,
          },
        ],
      };
    },
  },
};
